<template>
  <div>
    <page-header title="Dashboard" :avatar="userInfo.avatar_preview" />

    <stats />

    <calendar-box>
      <template #header>
        <a-dropdown :trigger="['click']">
          <a-button
            class="align-right"
            size="large"
            icon="plus"
            type="primary"
          />

          <a-menu slot="overlay">
            <a-menu-item @click="onCellClick">
              Dodaj dostępność
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>

      <template #calendar>
        <a-spin :spinning="loading">
          <div class="spin-content">
            <calendar
              :on-event-click="onEventClick"
              @cell-click="onCellClick"
              @ready="viewChanged"
              @view-change="viewChanged"
              :events="events"
            >
              <template v-slot:title="{ view }">
                <span v-if="view.id === 'week'">
                  {{ view.startDate.format('MMMM') }}
                  {{ view.startDate.format('YYYY') }}
                  (Tydzień {{ view.startDate.getWeek() }})
                </span>
              </template>

              <template v-slot:weekday-heading="{ heading }">
                <span>
                  {{ heading.date.format('ddd') }}
                  <strong>{{ heading.date.format('D.MM') }}</strong>
                </span>
              </template>

              <template v-slot:event="{ event }">
                <calendar-slot :event="event" />
              </template>
            </calendar>
          </div>
        </a-spin>
        <availability-modal ref="availabilityModal" @submit="fetchSlots" />
        <confirm-reservation-modal
          ref="confirmReservationModal"
          @submit="fetchSlots"
        />
        <slot-modal
          ref="slotModal"
          @calendarChanged="closeModalsAndFetchSlots"
          @examToggled="fetchSlots"
        />
      </template>
    </calendar-box>
  </div>
</template>

<script>
import CalendarView from '@/views/ExtendableBases/CalendarView'
import CalendarBox from '@/components/calendar/CalendarBox'
import moment from 'moment'
import ConfirmReservationModal from '@/components/modals/ConfirmReservationModal/'
import { isDate } from 'lodash'

export default {
  extends: CalendarView,
  components: {
    ConfirmReservationModal,
    CalendarBox
  },
  computed: {
    slotFilterParams() {
      return {
        timespan_after: moment(this.startDate).format('YYYY-MM-DD'),
        timespan_before: moment(this.endDate).format('YYYY-MM-DD')
      }
    }
  },
  methods: {
    onCellClick(event) {
      const dateClicked = isDate(event) ? event : undefined

      if (dateClicked && moment(event).isBefore(moment())) {
        this.$message.error('Nie można dodać dostępności, dla przeszłych dat.')
        return
      }
      this.$refs.availabilityModal.openModal(
        dateClicked,
        this.$store.state.userInfo.id
      )
    },
    openSlotModal(event) {
      const pending = event.slot_type === 'pending'
      if (pending) {
        const reservationId = event.reserved_slot.reservation
        this.openReservationConfirmModal(reservationId)
      } else {
        this.$refs.slotModal.openModal(event.id)
      }
    },
    openReservationConfirmModal(reservationId) {
      this.$refs.confirmReservationModal.openModal(reservationId)
    }
  }
}
</script>
